import React, { createContext, useContext, useState } from "react";

const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const [companyAccountId, setCompanyAccountId] = useState(() => {
    return localStorage.getItem("companyAccountId");
  });

  return (
    <CompanyContext.Provider value={{ companyAccountId, setCompanyAccountId }}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};


